import { createFeatureSelector, createSelector, MemoizedSelector } from '@ngrx/store';
import { nameof } from '@symphony-solo/shared/utils/src';
import { ICompanyGroupFeature } from './company-group.feature.state';
import { CompanyGroupState } from './company-group.state';

export const getCompanyGroupState: MemoizedSelector<ICompanyGroupFeature, CompanyGroupState> = createFeatureSelector<CompanyGroupState>(
  nameof<ICompanyGroupFeature>('CompanyGroupFeature')
);

export const getIsLoading = createSelector(getCompanyGroupState, (state: CompanyGroupState) => state.isLoading);

export const getFailures = createSelector(getCompanyGroupState, (state: CompanyGroupState) => state.failures);

export const getCompanyGroup = createSelector(getCompanyGroupState, (state: CompanyGroupState) => state.CompanyGroup);